import React, { useState } from "react";
import axios from "axios";
import { serverUrl } from "../../../../Constant/Static/config";
import PopModal from '../../../../Constant/Custom/Models/PopModal'
import './rankInsertion.css'

const RankInsertion = () => {

  const [formData, setFormData] = useState({
    appNo: '',
    appName: '',
    dob: '',
    gender: '',
    community: '',
    univRegno: '',
    nativity: '',
    ob1: '',
    max1: '',
    ob2: '',
    max2: '',
    ob3: '',
    max3: '',
    ob4: '',
    max4: '',
    ob5: '',
    max5: '',
    ob6: '',
    max6: '',
    ob7: '',
    max7: '',
    ob8: '',
    max8: '',
    avg: '',
    preSem: '',
    finSem: '',
    maxTotal: '',
    obtTotal: ''
  });
  const [ocRank, setOcRank] = useState('')
  const [commRank, setCommRank] = useState('')

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false)
  const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });
  const [onConfirm, setOnconfirm] = useState(() => () => { });

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);


  const [errors, setErrors] = useState({})



  function format(value) {
    let sign = value >= 0 ? 1 : -1;
    return (Math.floor(Math.abs(value) * 10000) / 10000 * sign).toFixed(4);
  }

  const setDefaultForm = () => {
    setFormData({
      appNo: '',
      appName: '',
      dob: '',
      gender: '',
      community: '',
      univRegno: '',
      nativity: '',
      ob1: '',
      max1: '',
      ob2: '',
      max2: '',
      ob3: '',
      max3: '',
      ob4: '',
      max4: '',
      ob5: '',
      max5: '',
      ob6: '',
      max6: '',
      ob7: '',
      max7: '',
      ob8: '',
      max8: '',
      avg: '',
      preSem: '',
      finSem: '',
      maxTotal: '',
      obtTotal: ''
    })
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }))
  }

  const handleCalculate = () => {

    // // console.log(formData);


    let o1 = parseInt(formData['ob1']), o2 = parseInt(formData['ob2']), o3 = parseInt(formData['ob3']), o4 = parseInt(formData['ob4']), o5 = parseInt(formData['ob5']), o6 = parseInt(formData['ob6']), o7 = parseInt(formData['ob7']), o8 = parseInt(formData['ob8']);
    let m1 = parseInt(formData['max1']), m2 = parseInt(formData['max2']), m3 = parseInt(formData['max3']), m4 = parseInt(formData['max4']), m5 = parseInt(formData['max5']), m6 = parseInt(formData['max6']), m7 = parseInt(formData['max7']), m8 = parseInt(formData['max8']);
    let avg, preSem, finSem, maxTotal, obtTotal;

    // console.log(m1 != "0" && m2 != "0" && m3 != "0" && m4 != "0" && m5 != "0" && m6 != "0" && m7 == "0" && m8 == "0" && o7 == "0" && o8 == "0");
    // console.log(o1 != "" && m1 != "" &&
    //   o2 != "" && m2 != "" &&
    //   o3 != "" && m3 != "" &&
    //   o4 != "" && m4 != "" &&
    //   o5 != "" && m5 != "" &&
    //   o6 != "" && m6 != "" &&
    //   o7 != "" && m7 != "");

    // console.log(o7 != "1");



    if (o1 <= m1 && o2 <= m2 && o3 <= m3 && o4 <= m4 && o5 <= m5 && o6 <= m6 && o7 <= m7 && o8 <= m8) {
      avg = ((o1 + o2 + o3 + o4 + o5 + o6 + o7 + o8) / (m1 + m2 + m3 + m4 + m5 + m6 + m7 + m8)) * 100;
      obtTotal = o1 + o2 + o3 + o4 + o5 + o6 + o7 + o8;
      maxTotal = m1 + m2 + m3 + m4 + m5 + m6 + m7 + m8;
      if (m1 == "0" && m2 == "0" && m3 == "0" && m4 == "0" && m5 == "0" && m6 == "0" && m7 == "0" && m8 == "0") {
        //error
      }
      //regular
      else if (m1 != "0" && m2 != "0" && m3 != "0" && m4 != "0" && m5 != "0" && m6 != "0" && m7 == "0" && m8 == "0" && o7 == "0" && o8 == "0") {
        preSem = (o5 / m5) * 100;
        finSem = (o6 / m6) * 100;
      }  //sandwich 7
      else if (m1 != "0" && m2 != "0" && m3 != "0" && m4 != "0" && m5 != "0" && m6 != "0" && m7 != "0" && m8 == "0" && o7 != "0" && o8 == "0") {
        preSem = (o6 / m6) * 100;
        finSem = (o7 / m7) * 100;
      } //lateral
      else if (m1 == "0" && m2 == "0" && m3 != "0" && m4 != "0" && m5 != "0" && m6 != "0" && m7 == "0" && m8 == "0" && o7 == "0" && o8 == "0") {
        preSem = (o5 / m5) * 100;
        finSem = (o6 / m6) * 100;
      } //sandwich lateral 7
      else if (m1 == "0" && m2 == "0" && m3 != "0" && m4 != "0" && m5 != "0" && m6 != "0" && m7 != "0" && m8 == "0" && o7 != "0" && o8 == "0") {
        preSem = (o6 / m6) * 100;
        finSem = (o7 / m7) * 100;

      } //sandwich 8
      else if (m1 != "0" && m2 != "0" && m3 != "0" && m4 != "0" && m5 != "0" && m6 != "0" && m7 != "0" && m8 != "0" && o7 != "0" && o8 != "0") {
        preSem = (o7 / m7) * 100;
        finSem = (o8 / m8) * 100;
      } //sandwich lateral 8
      else if (m1 == "0" && m2 == "0" && m3 != "0" && m4 != "0" && m5 != "0" && m6 != "0" && m7 != "0" && m8 != "0" && o7 != "0" && o8 != "0") {
        preSem = (o7 / m7) * 100;
        finSem = (o8 / m8) * 100;
      }
      else if (m1 == "0" && m2 != "0" && m3 != "0" && m4 != "0" && m5 != "0" && m6 != "0" && m7 == "0" && m8 == "0" && o7 == "0" && o8 == "0") {
        preSem = (o5 / m5) * 100;
        finSem = (o6 / m6) * 100;
      } 
      // Regular - Semester 2 not available
      else if (m1 != "0" && m2 == "0" && m3 != "0" && m4 != "0" && m5 != "0" && m6 != "0" && m7 == "0" && m8 == "0" && o7 == "0" && o8 == "0") {
        preSem = (o5 / m5) * 100;
        finSem = (o6 / m6) * 100;
      }


      // console.log("Presem :", preSem);

    } else {
      setModalType({
        icon: 'error',
        title: 'Error',
        text: "Some semester marks are invalid"
      })
      openModal();
      setOnconfirm(() => closeModal)
    }

    setFormData((prev) => (
      {
        ...prev,
        'preSem': format(preSem),
        'finSem': format(finSem),
        'avg': format(avg),
        'maxTotal': maxTotal,
        'obtTotal': obtTotal
      }
    ))
    // console.log(maxTotal, obtTotal);
    setShowSubmit(true)
  }

  // const validate = () => {
  //   for (int i)
  // }

  const handleCheckBtn = async () => {
    if (formData.appNo.trim().length === 0) {
      setModalType({
        icon: 'info',
        title: 'Required Field..!',
        text: "Kindly enter the application number"
      })
      openModal();
      setOnconfirm(() => closeModal)
      return;
    }
    try {
      const response = await axios.post(`${serverUrl}/api/admin/rank/fetch-details`, {
        appNo: formData.appNo
      });

      const { appNo, appName, dob, gender, community, univRegno, nativity,
        ob1, max1, ob2, max2, ob3, max3, ob4, max4, ob5, max5, ob6, max6,
        ob7, max7, ob8, max8, avg, preSem, finSem, maxTotal, obtTotal, ocRank, commRank } = response.data.studDetails
      setOcRank(ocRank);
      setCommRank(commRank);

      if (response.status === 200) {
        setFormData({
          appNo, appName, dob: dob?.replace(/-/g, ''), gender, community,
          univRegno, nativity, ob1, max1, ob2, max2,
          ob3, max3, ob4, max4, ob5, max5, ob6, max6,
          ob7, max7, ob8, max8, avg, preSem, finSem,
          maxTotal, obtTotal
        })
      }
    } catch (error) {
      // console.error(error);
      if (error.response.status === 404) {
        setModalType({
          icon: 'error',
          title: 'Error',
          text: "Student not found. Kindly enter the details manually"
        })
        openModal();
        setOnconfirm(() => closeModal)
      }
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {

      const response = await axios.post(`${serverUrl}/api/admin/rank/insert-rank`, { formData });
      if (response.status === 200) {
        setModalType({
          icon: 'success',
          title: 'Success',
          text: response.data.message
        })
        openModal();
        setOnconfirm(() => closeModal)
      }
      setDefaultForm();
      setOcRank('');
      setCommRank('');
    } catch (error) {
      if (error.response) {
        setModalType({
          icon: 'error',
          title: 'Error',
          text: error.response.data.message
        })
        openModal();
        setOnconfirm(() => closeModal)
      }
    } finally {
      setShowSubmit(false)
    }

  }




  return (
    <div className='rank-insertion-wrapper'>
      <div className='rank-insertion-container'>
        <p className='rank-insertion-title' style={{ color: 'red' }}>New Rank Insertion</p>
        <form onSubmit={handleSubmit}>
          <div className="rank-insertion-form-container">
            <div className='rank-insert-form-item rank-insert-check-container'>
              <label>Applicantion No :</label>
              <input style={{ width: "55%" }} onChange={handleChange} value={formData.appNo} type="text" name="appNo" maxLength={7} required />
              <div className="rank-insert-form-item rank-insert-check-container">
                <button
                  onClick={handleCheckBtn}
                  onKeyDown={(e) => { if (e.key === 'Enter') handleCheckBtn(e); }}
                  type="button"
                  className="route-home-button rank-insertion-check-btn"
                  name="checkBtn"
                >
                  Check
                </button>
                <div className="button-container">
                  <button onClick={handleCalculate} type="button">Calculate</button>
                  <button type="submit" disabled={!showSubmit}>Submit</button>
                </div>
              </div>

              {
                ocRank && commRank && (
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <h2>OC Rank : {ocRank}</h2>
                    <h2>Community Rank : {commRank}</h2>
                  </div>
                )
              }
            </div>
            <div className="app-detail-form-container">
              <div className='rank-insert-form-group'>

                <div className='rank-insert-form-item'>
                  <label>Applicant Name :</label>
                  <input onChange={handleChange} type="text" value={formData.appName} name="appName" required />
                </div>
                <div className='rank-insert-form-item'>
                  <label>Date Of Birth (YYYYMMDD) :</label>
                  <input onChange={handleChange} type="text" value={formData.dob} name="dob" required />
                </div>
                <div className='rank-insert-form-item'>
                  <label>Gender :</label>
                  <select value={formData.gender} onChange={handleChange} name="gender" required>
                    <option value=''>Choose the gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Others</option>
                  </select>
                </div>
                <div className="rank-insert-form-item">
                  <label>Community:</label>
                  <select value={formData.community} onChange={handleChange} name="community" required>
                    <option value="">Choose the community</option>
                    <option value="OC">OC</option>
                    <option value="BC">BC</option>
                    <option value="BCM">BCM</option>
                    <option value="MBC">MBC</option>
                    <option value="SC">SC</option>
                    <option value="SCA">SCA</option>
                    <option value="ST">ST</option>
                  </select>
                </div>
                <div className="rank-insert-form-item">
                  <label htmlFor="univ_regno">University Regno :</label>
                  <input value={formData.univRegno} onChange={handleChange} type="text" name="univRegno" placeholder="Register Number" required />
                </div>
                <div className="rank-insert-form-item">
                  <label htmlFor="nativity">Nativity</label>
                  <select value={formData.nativity} onChange={handleChange} name="nativity" required>
                    <option value="">Choose the Nativity</option>
                    <option value="1">TamilNadu</option>
                    <option value="0">Others</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="sem-detail-form-container">
              <div className="rank-insert-form-group">

                <div className="rank-insert-form-item">
                  <label >SEMESTER 1 :</label>
                  <input value={formData.ob1} onChange={handleChange} type="text" name="ob1" id="ob1" placeholder="Obtained mark" required />
                  <input value={formData.max1} onChange={handleChange} type="text" name="max1" id="max1" placeholder="Maximum mark" required />
                </div>
                <div className="rank-insert-form-item">
                  <label >SEMESTER 2</label>
                  <input value={formData.ob2} onChange={handleChange} type="text" name="ob2" id="ob2" placeholder="Obtained mark" required />
                  <input value={formData.max2} onChange={handleChange} type="text" name="max2" id="max2" placeholder="Maximum mark" required />
                </div>
                <div className="rank-insert-form-item">
                  <label >SEMESTER 3</label>
                  <input value={formData.ob3} onChange={handleChange} type="text" name="ob3" id="ob3" placeholder="Obtained mark" required />
                  <input value={formData.max3} onChange={handleChange} type="text" name="max3" id="max3" placeholder="Maximum mark" required />
                </div>
                <div className="rank-insert-form-item">
                  <label >SEMESTER 4</label>
                  <input value={formData.ob4} onChange={handleChange} type="text" name="ob4" id="ob4" placeholder="Obtained mark" required />
                  <input value={formData.max4} onChange={handleChange} type="text" name="max4" id="max4" placeholder="Maximum mark" required />
                </div>
                <div className="rank-insert-form-item">
                  <label >SEMESTER 5</label>
                  <input value={formData.ob5} onChange={handleChange} type="text" name="ob5" id="ob5" placeholder="Obtained mark" required />
                  <input value={formData.max5} onChange={handleChange} type="text" name="max5" id="max5" placeholder="Maximum mark" required />
                </div>
                <div className="rank-insert-form-item">
                  <label >SEMESTER 6</label>
                  <input value={formData.ob6} onChange={handleChange} type="text" name="ob6" id="ob6" placeholder="Obtained mark" required />
                  <input value={formData.max6} onChange={handleChange} type="text" name="max6" id="max6" placeholder="Maximum mark" required />
                </div>
                <div className="rank-insert-form-item">
                  <label >SEMESTER 7</label>
                  <input value={formData.ob7} onChange={handleChange} type="text" name="ob7" id="ob7" placeholder="Obtained mark" required />
                  <input value={formData.max7} onChange={handleChange} type="text" name="max7" id="max7" placeholder="Maximum mark" required />
                </div>
                <div className="rank-insert-form-item">
                  <label >SEMESTER 8</label>
                  <input value={formData.ob8} onChange={handleChange} type="text" name="ob8" id="ob8" placeholder="Obtained mark" required />
                  <input value={formData.max8} onChange={handleChange} type="text" name="max8" id="max8" placeholder="Maximum mark" required />
                </div>
              </div>
            </div>
          </div>
          <div className='pre-avg-container'>

            <div className="rank-insert-form-group">
              <div className="rank-insert-form-item">
                <label>Obtained Total :</label>
                <input value={formData['obtTotal']} type="number" name="maxTotal" readOnly />
              </div>
              <div className="rank-insert-form-item">
                <label>Maximum Total :</label>
                <input value={formData['maxTotal']} type="number" name="obtTotal" readOnly />
              </div>
              <div className="rank-insert-form-item">
                <label>Pre Sem :</label>
                <input value={formData['preSem']} type="number" name="presem" readOnly />
              </div>
              <div className="rank-insert-form-item">
                <label>Final Sem :</label>
                <input value={formData['finSem']} type="number" name="finsem" readOnly />
              </div>
              <div className="rank-insert-form-item">
                <label>Average :</label>
                <input value={formData['avg']} type="number" name="avg" readOnly />
              </div>
            </div>


          </div>
          <div style={{ position: 'relative', alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <PopModal
              isOpen={isModalOpen}
              type={modalType}
              confirmButtonText="OK"
              onConfirm={onConfirm}
            />
          </div>
        </form>
      </div>
    </div>

  )
}

export default RankInsertion;